export const IMPERSONATE = 'IMPERSONATE';
export const CLEAR_BACKUP = 'CLEAR_BACKUP';
export const SHOW_IMPERSONATE = 'SHOW_IMPERSONATE';
export const HIDE_IMPERSONATE = 'HIDE_IMPERSONATE';
export const FILL_COMPANIES = 'FILL_COMPANIES';
export const FILL_ACCOUNTS = 'FILL_ACCOUNTS';
export const DO_IMPERSONATE = 'DO_IMPERSONATE';
export const IMPERSONATE_SUCCESS = 'IMPERSONATE_SUCCESS';
